import * as React from 'react';
import { SVGProps } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
const AnalisysIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g strokeLinecap="round">
      <path d="M20 16h-3.465a1 1 0 0 0-.832.445l-.406.609a1 1 0 0 1-.832.445h-4.93a1 1 0 0 1-.832-.445l-.406-.609A1.002 1.002 0 0 0 7.464 16H4a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1ZM9 13v-2.33M12 13V9.5m3 3.5V7.17" />
      <path d="M20 16V5.571C20 4.703 19.204 4 18.222 4H5.778C4.796 4 4 4.703 4 5.571V16" />
    </g>
  </svg>
);

export default AnalisysIcon;
